import cn from 'clsx'
import { FC } from 'react'

import { Typography } from '@/components/ui'

import { IMoveSegmentParams } from '@/types/highlight.interface'
import { displayTime } from '@/utils/displayTime'

const HighlightDragOverlay: FC<{
	segment: IMoveSegmentParams['segment']
}> = ({ segment }) => {
	return (
		<div
			className={cn(
				'rounded-[8px] bg-neutral-100 shadow-[0_8px_24px_rgba(0,0,0,0.16)] px-3 py-2 cursor-grabbing'
			)}
		>
			<Typography variant='text' className='!text-[12px] text-gray-450'>
				{displayTime(segment.start)}
				{' - '}
				{displayTime(segment.end)}
			</Typography>

			<Typography
				variant='text'
				className='text-gray-600 overflow-hidden !whitespace-nowrap truncate'
			>
				{segment.description}
			</Typography>
		</div>
	)
}

export default HighlightDragOverlay
